import React, {useContext, useState, useEffect} from 'react';
import {
  getAccessToken,
  storeAccountId,
  storeBrandId,
  storeOperatorId,
  storeProfileInfo,
} from '../database/DataBase';
import {getProfileInfo, getBouquesForAccount} from '../network/Network';
import {toast} from 'react-toastify';

export const NetworkProviderContext = React.createContext('DEFAULT');

export function GetNetworkProvider() {
  return useContext(NetworkProviderContext);
}

export default function NetworkProvider(props) {

  const [profileInfo, setProfileInfo] = useState(null);
  const [bouqueInfo, setBouqueInfo] = useState(null);
  
  const reload = () => {
    fetchProfileData();
  };
  
  useEffect(() => {
    getAccessToken()
      .then((data) => {
        if(data != null){
          fetchProfileData();
        }
      });    
  }, []);
  
  useEffect(() => {
    if(profileInfo != null){
      fetchBouques();
    }
  }, [profileInfo]);

  const fetchBouques = () => {
    getBouquesForAccount()
      .then((bouques) => {
        if (bouques.success === true && bouques.status === 200) {
          setBouqueInfo(bouques.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchProfileData = () => {
    getProfileInfo(true)
      .then((reply) => {
        if (reply.success && (reply.status === 200 || reply.status === 201)) {
          storeAccountId(reply.data.accounts[0].id);
          storeBrandId(reply.data.accounts[0].brand_id);
          storeOperatorId(reply.data.profile.sublocation_details.operator_id);
          storeProfileInfo(reply);
          setProfileInfo(reply);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <NetworkProviderContext.Provider
      value={{
        profileInfo: profileInfo,
        bouqueInfo: bouqueInfo,
        reload: reload,
      }}>
      {props.children}
    </NetworkProviderContext.Provider>
  );
}
